import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyTopBar() {
  return <div className="sticky top-0 z-50 bg-carbon text-white py-2 px-4 text-center text-xs md:text-sm" data-id="element-239">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-1" data-id="element-240">
        <span data-id="element-241">⚡ PRECIO DE LANZAMIENTO — TERMINA EN:</span>
        <CountdownTimer variant="inline" data-id="element-242" />
        <span className="hidden md:inline" data-id="element-243">
          — Después sube $10.000 y no baja.
        </span>
      </div>
    </div>;
}